import React from "react";
import { connect } from "react-redux";
import helperNumbers from "../../../helpers/numbers";
import { Tooltip, Popover, OverlayTrigger } from "react-bootstrap";
// import constantsReportCampaign from "./constants/reportCampaign";
// import statusCampaign from "./constants/status-campaign";

const CardReport = ({
  countSitePublisher,
  countAllPositions,
  countViewAdvertiseInPositionOnSitePublisher,
  timeSecondViewAdvertiseInPositionOnSitePublisher,
  income,
}) => {
  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0">
      <div className="container-fluid container-card-report py-0 py-lg-4">
        <div className="row">
          <div className="col-12 col-sm-6 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          countSitePublisher
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(
                        countSitePublisher + ""
                      )
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(countSitePublisher + "")}
                  </div>
                </div>
              </OverlayTrigger>

              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                تعداد سایت
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          countAllPositions
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(
                        countAllPositions + ""
                      )
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(countAllPositions + "")}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-center text-dark">
                تعداد جایگاه های
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          countViewAdvertiseInPositionOnSitePublisher
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4 ">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(
                        countViewAdvertiseInPositionOnSitePublisher + ""
                      )
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(
                      countViewAdvertiseInPositionOnSitePublisher + ""
                    )}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                تعداد نمایش
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          timeSecondViewAdvertiseInPositionOnSitePublisher
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4 ">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(
                        timeSecondViewAdvertiseInPositionOnSitePublisher + ""
                      )
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(
                      timeSecondViewAdvertiseInPositionOnSitePublisher + ""
                    )}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                زمان نمایش
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(income)
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4 ">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(income + "")
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(income + "")}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                درآمد (تومان)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    countSitePublisher: state.report.count_all_site_publisher,
    countAllPositions: state.report.count_all_positions,
    countViewAdvertiseInPositionOnSitePublisher:
      state.report.count_view_advertise_in_position_on_site_publisher,
    timeSecondViewAdvertiseInPositionOnSitePublisher:
      state.report.time_second_view_advertise_in_position_on_site_publisher,
    income: state.report.income,
  };
};

export default connect(mapStateToProps, null)(CardReport);
